<template>
    <p class="flex items-center cursor-pointer" @click="like">
        <FontAwesomeIcon :icon="['fas', 'heart']" class="text-grey-200 mr-2"></FontAwesomeIcon>
        <span class="text-dark">{{ likes }}</span>
    </p>
</template>

<script>
import {FontAwesomeIcon} from "@fortawesome/vue-fontawesome";

export default {
    components: {
        FontAwesomeIcon
    },
    props: {
        likes: [Number, String]
    },
    methods: {
        like() {
            // todo: make like do something
        }
    }
};
</script>

<style scoped>

</style>
